import { Injectable } from '@angular/core';
import { PurlyServiceConfig } from '@jeppesen-foreflight/jmkw-types';

/**
 * Runtime configuration loaded from assets/config.json at application startup.
 * This allows Docker containers to inject configuration without rebuilding the application.
 */
export interface RuntimeConfig {
  purly: PurlyServiceConfig;
}

/**
 * Service that provides runtime configuration loaded from config.json.
 * This configuration is loaded before Angular bootstraps, allowing
 * Docker containers to inject environment-specific values at startup.
 */
@Injectable({
  providedIn: 'root'
})
export class RuntimeConfigService {
  private config: RuntimeConfig | null = null;

  /**
   * Set the runtime configuration. Called during app initialization.
   */
  setConfig(config: RuntimeConfig): void {
    this.config = config;
  }

  /**
   * Get the runtime configuration.
   * @throws Error if configuration hasn't been loaded yet
   */
  getConfig(): RuntimeConfig {
    if (!this.config) {
      throw new Error('Runtime configuration not loaded. Ensure config is loaded before app initialization.');
    }
    return this.config;
  }

  /**
   * Get Purly service configuration
   */
  getPurlyConfig(): PurlyServiceConfig {
    return this.getConfig().purly;
  }

  /**
   * Check if configuration has been loaded
   */
  isConfigLoaded(): boolean {
    return this.config !== null;
  }
}
